import { createContext } from "@-/com.npmjs.use-context-selectors";
import { defaultError } from "@-/com.npmjs.react-context-default-error";
import type {
  DrillMorphemeSlice,
  GraphemeMorphemeMnemonicsPanelMorphemeSlice,
} from "@-/dev.improve.haniverse.lib.morpheme.entities";
import type { ResolvedQuery } from "@-/dev.improve.haniverse.lib.query-options";
import type { GraphemeDrillType } from "#drill-branch-types";

/**
 * The grapheme branch of a drill: published by `GraphemeDrillGateSuspense` once it has narrowed
 * both grapheme slices. Only components that belong to a grapheme drill read it (the glyph, the
 * pronunciation hint, the mnemonics back, the voice-study turns); a word drill never mounts it.
 */
export type GraphemeDrillContextValue = {
  drillType: GraphemeDrillType;
  /** The drill front's slice (strokes). */
  front: ResolvedQuery<DrillMorphemeSlice | null>;
  /** The grapheme's mnemonics panel slice (gloss, readings, mnemonic). */
  slice: ResolvedQuery<GraphemeMorphemeMnemonicsPanelMorphemeSlice | null>;
};

export const GraphemeDrillContext = createContext(
  defaultError<GraphemeDrillContextValue>("GraphemeDrillContext"),
);
